<script setup>
const props = defineProps({
  list: {
    type: Array,
    required: true,
    default: []
  },
  // 是否纵向排列
  isColumn: {
    type: Boolean,
    default: false
  }
})
// 选中的属性值颜色区分
const handleTagType = (item) => {
  const enumList = ['warning', 'primary', 'success', 'danger']
  return enumList[simpleHash(item) % 4]
}
// 使用哈希函数对id编码
const simpleHash = (input) => {
  let hash = 0;
  for (let i = 0; i < input.length; i++) {
    hash += input.charCodeAt(i);  // 获取字符的 UTF-16 编码值并累加
  }
  return hash;
};
</script>

<template>
  <span :style="props.isColumn && (props.list.length > 1 && index !== (props.list.length - 1)) ? 'margin-bottom: 10px;width: 100%' : ''" :class="props.isColumn && (props.list.length > 1 && index !== (props.list.length - 1)) ? 'flex flex_warp mg_r_1' : 'mg_r_1'" v-for="(item, index) in props.list" :key="`itemPropTag${item}${index}`">
    <el-tag v-show="item !== null && item !== ''" :type="handleTagType(item)">{{item}}</el-tag>
  </span>
</template>

<style scoped>
el-tag:last-child {
  margin-bottom: 0!important;
}
</style>
